<template>
  <v-container
    id="Login"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="6"
      >
        <v-slide-y-transition appear>
          <v-card
            class="pa-3 pa-md-5 mx-auto"
            light
          >
            <div
              v-if="!tokencontrato"
            >
              <pages-heading class="text-center text-h2">
                Empresa não encontrada
              </pages-heading>
            </div>
            <div v-else>
              <div
                v-if="inativo"
              >
                <div
                  class="transition-swing font-weight-light text-center text-h3"
                  v-text="inativo"
                /> <br>
                <v-btn
                  id="idSuport2"
                  :color="corPrimaria"
                  dark
                  class="col-3 col-sm-4"
                  target="_blank"
                  :href="whatsapp"
                  @click="reload()"
                >
                  <v-icon
                    id="iconSuport"
                    color="#ffffff"
                  >
                    mdi-account-question
                  </v-icon>
                  <h5>SUPORTE</h5>
                </v-btn>
              </div>
              <div
                v-else
              >
                <!-- <div id="imagem">
                  <v-img
                    :src="imagem"
                  />
                </div> -->
                <pages-heading
                  id="cabecalho"
                  class="text-center text-h2"
                  :style="styleObject"
                >
                  {{ empresaNome }}
                </pages-heading>
                <pages-heading
                  class="text-h3"
                  :style="styleObject"
                >
                  <b>Faça o login</b>
                </pages-heading>
                <!-- <validation-observer> -->
                <v-form
                  ref="form"
                  v-model="valid"
                  @submit.prevent="logar"
                >
                  <v-row class="text-center">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <tex-field-with-validation
                        :value="login.email"
                        :color="corPrimaria"
                        class="text-h6 blue--text title"
                        rules="email"
                        required
                        type="email"
                        label="Email"
                        prepend-inner-icon="mdi-email-fast"
                        @input="(value) => { login.email = value }"
                      />
                      <tex-field-with-validation
                        :value="login.password"
                        :color="corPrimaria"
                        rules="required"
                        :type="inputType ? 'text' : 'password'"
                        label="Senha"
                        class="text-h6"
                        prepend-inner-icon="mdi-lock"
                        :append-icon="inputType ? 'mdi-eye' : 'mdi-eye-off'"
                        @input="(value) => { login.password = value }"
                        @click:append="inputType = !inputType"
                        @keyup.enter="logar()"
                      />
                      <div
                        class="text-left"
                      >
                        Esqueceu sua senha?
                        <span>
                          <router-link
                            to="/recover"
                            :style="styleObject"
                          >Clique aqui para recuperar.</router-link>
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col
                      cols="12"
                      lg="5"
                    >
                      <v-btn
                        id="logar"
                        small
                        class="v-btn--block"
                        :color="corPrimaria"
                        @click="logar()"
                      >
                        Acessar o sistema
                      </v-btn>
                    </v-col>
                  </v-row>
                  <base-material-snackbar
                    v-model="snackbar.visible"
                    :timeout="snackbar.timeout"
                    :top="true"
                    :type="snackbar.color"
                  >
                    {{ snackbar.message }}
                  </base-material-snackbar>
                </v-form>
              </div>
              <!-- </validation-observer> -->
            </div>
          </v-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Login from '../../services/login'
  import utils from '../../services/utils'
  export default {

    name: 'PageLogin',
    components: {
      PagesHeading: () => import('./components/Heading'),
    },
    mixins: [utils],

    data: () => ({
      exibePf: true,
      valid: false,
      tokencontrato: '',
      login: {
        email: '',
        password: '',
      },
      usuarioIdentificado: false,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      corPrimaria: localStorage.corPrimaria,
      verifylink: '',
      inativo: '',
      empresaNome: '',
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: '',
        timeout: 3000,
      },
      emailRules: [
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail é obrigatório',
      ],
      user: [],
      dialog: {
        visible: false,
        message: '',
      },
      validuser: false,
      // inputType: 'password',
      inputType: false,
      versao: localStorage.getItem('versao'),
    }),

    // computed: {
    //   isPassword () {
    //     return this.inputType === 'password'
    //   },
    // },

    mounted () {
      this.valid = false
      this.invalid = true

      this.tokencontrato = localStorage.tokencontrato

      Login.verificaEmpresa(this.tokencontrato).then(resposta => {
        this.empresaNome = resposta.data.empresa

        if (this.versao < resposta.data.versao) {
          localStorage.setItem('versao', resposta.data.versao)

          this.$router.go()
        }
      }).catch(e => {
        if (e.data.errors === 'Empresa não encontrada') {
          this.empresaNome = ''
          this.tokencontrato = ''
          this.showSnackbar('error', 3000, 'Empresa não encontrada.')
        }
      })
    },

    methods: {
      // togglePassword () {
      //   this.inputType = this.isPassword ? 'text' : 'password'
      // },

      reload () {
        location.reload()
      },

      logar () {
        Login.logar(this.login, this.tokencontrato).then(resposta => {
          if (resposta.data.result === 'cadastro-usuario-ok') {
            this.login.validuser = true

            this.user = resposta.data

            const versao = localStorage.versao
            const corPrimaria = localStorage.corPrimaria
            const corSecondaria = localStorage.corSecondaria
            const corError = localStorage.corError

            const colunasSalvasEntrega = this.lerLocalStorageJSON('colunasSalvasEntrega')
            const colunasSalvasNotaFiscais = this.lerLocalStorageJSON('colunasSalvasNotaFiscais')

            localStorage.clear()

            localStorage.setItem('versao', versao)
            localStorage.setItem('tokencontrato', this.tokencontrato)
            localStorage.setItem('corPrimaria', corPrimaria)
            localStorage.setItem('corSecondaria', corSecondaria)
            localStorage.setItem('corError', corError)
            localStorage.setItem('nome', resposta.data.nome)
            localStorage.setItem('username', resposta.data.username)
            localStorage.setItem('status', resposta.data.status)

            if (colunasSalvasEntrega) {
              localStorage.setItem('colunasSalvasEntrega', JSON.stringify(colunasSalvasEntrega))
            }

            if (colunasSalvasNotaFiscais) {
              localStorage.setItem('colunasSalvasNotaFiscais', JSON.stringify(colunasSalvasNotaFiscais))
            }

            this.showSnackbar('success', 3000, 'Login realizado com sucessso')

            this.emitLogin()

            this.$router.push('/dashboard')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.message === 'ERRO LOGIN: campo username não foi informado') {
            this.login.validuser = false
            this.showSnackbar('error', 3000, 'Usuário não informado.')
          } else if (e.data.message === 'ERRO LOGIN: campo password não foi informado') {
            this.login.validuser = false
            this.showSnackbar('error', 3000, 'Senha não informada.')
          } else if (e.data.message === 'ERRO LOGIN: Username ou Password informado não conferem') {
            this.login.validuser = false
            this.showSnackbar('error', 3000, 'Username ou Password informado não conferem')
          } else if (e.data.message === 'ERRO LOGIN: Username informado inválido') {
            this.login.validuser = false
            this.showSnackbar('error', 3000, 'Username informado inválido')
          }
        }).finally(f => { this.exibeProgress = false })
      },

      lerLocalStorageJSON (chave) {
        const valor = localStorage.getItem(chave)

        if (!valor || valor === 'undefined') {
          return null
        }

        try {
          return JSON.parse(valor)
        } catch (e) {
          console.warn(`Erro ao fazer parse de ${chave}`, e)
          return null
        }
      },

      emitLogin () {
        this.$root.$emit('dados-login', this.user)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      showDialog (message) {
        this.dialog.visible = true
        this.dialog.message = message
      },
    },
  }
</script>

<style lang="sass">
  .v-text-field input
    font-size: 1.2em

  #login
    .v-list-item__subtitle
      -webkic-line-clamp: initial
      -webkit-box-orient: initial

  #cabecalho
    color: #4caf50
    font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif
    font-weight: 800 !important

  #imagem
    margin-left: 30%
    margin-right: 25%
    width: 40%
    height: 40%

  #idSuport
    margin-left: 35%
    margin-right: 30%

  #logar
    border-radius: 8px

  #idSuport
    float: right
    margin-right: 2rem
    border-radius: 1.8rem

  #idSuport2
    margin: 0rem 0rem 0rem 12rem
    border-radius: 1.8rem

  #eye
    // margin: -2.5rem 0 0 36rem

</style>
